import { Link } from 'react-router-dom';
import { AffiliationNotice } from '../components/Disclaimer';

const COLS: { title: string; links: [string, string][] }[] = [
  { title: 'Leagues', links: [['NFL', '/nfl'], ['College', '/college']] },
  { title: 'Tools', links: [['Predict', '/predict'], ['Betting coach', '/betting'], ['Coach grades', '/grades'], ['Games given away', '/given-away'], ['Compare coaches', '/compare'], ['Breakdown', '/breakdown']] },
  { title: 'Kova', links: [['Ask Kova', '/ask'], ['Home', '/']] },
];

export function Footer() {
  return (
    <footer className="mt-10 bg-blueDark text-paper">
      <div className="container">
        <div className="grid grid-cols-1 gap-6 py-8 md:grid-cols-[1.4fr_2fr]">
          <div>
            <img src="/brand/logo-white.png" alt="Kova" className="h-12 w-auto" />
            <p className="mt-3 max-w-[36ch] text-[13px] text-paper/80">NFL and college football intelligence, with the reasoning shown.</p>
          </div>
          <div className="grid grid-cols-3 gap-4">
            {COLS.map((c) => (
              <div key={c.title}>
                <p className="mb-2 font-mono text-[11px] font-semibold uppercase tracking-[0.12em] text-paper/70">{c.title}</p>
                <ul className="flex flex-col gap-1.5">{c.links.map(([label, to]) => <li key={to}><Link to={to} className="text-[13px] font-medium text-paper/90 hover:text-paper hover:underline">{label}</Link></li>)}</ul>
              </div>
            ))}
          </div>
        </div>
        <div className="border-t border-white/15 py-4">
          <p className="mb-1 font-mono text-[11px] font-semibold uppercase tracking-[0.12em] text-paper/70">Responsible use</p>
          <p className="text-[12px] leading-relaxed text-paper/80">Kova provides statistical analysis and predictions for informational and entertainment purposes only. Nothing here is betting advice, a recommendation to wager, or a guarantee of any outcome. Odds and lines are gathered from public sources and may change. If you choose to bet, do so legally, responsibly, and within your means. Kova does not accept or place wagers.</p>
          <div className="mt-2"><AffiliationNotice /></div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-2 border-t border-white/15 py-3 pb-[calc(env(safe-area-inset-bottom,0px)+96px)] md:pb-3">
          <p className="text-[12px] text-paper/75">&copy; {new Date().getFullYear()} Kova. All rights reserved.</p>
          <p className="text-[12px] text-paper/75">Not betting advice.</p>
        </div>
      </div>
    </footer>
  );
}
